import { useCallback } from 'react';

import { useShopifyProducts } from './useShopifyProducts';

export const useAvailableProducts = (merchandiseIds: string[]) => {
  const shopifyProducts = useShopifyProducts({ merchandiseIds });

  const isProductAvailable = useCallback(
    ({ variant }: { variant: { gid: string } }) =>
      shopifyProducts.find((p) => p.variants.find((v) => v.id === variant.gid))
        ?.availableForSale,
    [shopifyProducts],
  );

  return { shopifyProducts, isProductAvailable };
};
